import { cn } from '@/lib/utils';

type TrueArtisLogoProps = {
  /** light = brown wordmark for cream backgrounds; dark = cream wordmark for chocolate backgrounds */
  variant?: 'light' | 'dark';
  className?: string;
  showTagline?: boolean;
};

const LOGO_SRC = {
  light: '/investor/true-artis-logo-light.svg',
  dark: '/investor/true-artis-logo-dark.svg',
} as const;

/** TRUE ARTIS wordmark — transparent PNG/SVG assets for reliable rendering in header and sidebar. */
export function TrueArtisLogo({
  variant = 'light',
  className,
  showTagline = true,
}: TrueArtisLogoProps) {
  return (
    <img
      src={LOGO_SRC[variant]}
      alt="TRUE ARTIS — Aesthetics Redefined"
      className={cn(
        'h-auto w-auto object-contain object-left',
        showTagline ? 'max-h-14' : 'max-h-10',
        className
      )}
      draggable={false}
    />
  );
}

export const TRUE_ARTIS_LOGO_LIGHT = LOGO_SRC.light;
export const TRUE_ARTIS_LOGO_DARK = LOGO_SRC.dark;
